import { Component, OnDestroy } from '@angular/core';
import { TemplateTypes } from '@lbmx/per-form-primeng';
import { PopupService } from '@lbmx/root-services';
import { PopupInstance } from '@lbmx/root-services/lib/popup/popup.interface';
import { merge, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Component({
  selector: 'app-wizard-popup',
  templateUrl: './wizard-popup.component.html',
  styleUrls: ['./wizard-popup.component.scss'],
})
export class WizardPopupComponent implements OnDestroy {
  public popups: PopupInstance[];
  public baseUrl = this.configProvider.AppSetting.uriBase.apiBaseUrl;
  public templateTypes = TemplateTypes;

  private _onDestroy = new Subject();

  constructor(
    public popupService: PopupService,
    private configProvider: ConfigProvider
  ) {
    const popupsSubscription = popupService.popups$.pipe(
      tap((popups) => {
        this.popups = popups;
      })
    );
    const closeSubscription = popupService.popups$.pipe(
      switchMap((popups) =>
        merge(
          // subscribe to cancel and submit events from each popup
          ...popups.map((popup) =>
            merge(popup.cancel$, popup.submit$).pipe(
              tap(() => popupService.closeWizard(popup))
            )
          )
        )
      )
    );
    merge(popupsSubscription, closeSubscription)
      .pipe(
        takeUntil(this._onDestroy),
        tap(() => {
          // PrimeNg removes the ui-overflow-hidden class when any modal dialog is closed
          // even if there are still other modal dialogs open
          // so we have to add it back manually after PrimeNg removes it
          setTimeout(() => {
            if (this.popups.length > 0) {
              document.body.classList.add('ui-overflow-hidden');
            }
          }, 0);
        })
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this._onDestroy.next();
  }
}
